import { useTranslation } from "react-i18next"

import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import Pagination from "@/components/Pagination/Pagination"
import SurveysShow from "@/features/pages/Surveys/SurveysShow"
import { useSurveysData } from "@/queries/queries"

export default function Surveys() {
  const surveyQuery = useSurveysData()
  const { t } = useTranslation()

  let content
  if (surveyQuery.isLoading) {
    content = <Loading />
  } else if (!surveyQuery.data?.data.length) {
    content = <NoMessage name={t("noMessages.surveys")} />
  } else {
    content = (
      <>
        <SurveysShow surveys={surveyQuery.data.data} />
        <Pagination pagination={surveyQuery.data?.meta} route="surveys" />
      </>
    )
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bolder mb-0">{t("pageTitles.surveys")}</h5>
      </div>

      {content}
    </div>
  )
}
